import DashboardTablePage from 'modules/pond/webview/DashboardTablePage'
import DiseaseDashboardTablePage from 'modules/pond/webview/DiseaseDashboardTablePage'
import ShrimpSizeTablePage from 'modules/pond/webview/ShrimpSizeTablePage'
import { useRoutes } from 'react-router-dom'

export default function WebviewRouter() {
  return useRoutes([
    {
      path: 'webview',
      children: [
        {
          path: 'warm',
          element: <div>warm</div>,
        },
        {
          path: 'farms/:farmId/ponds/:pondId/pond-dashboard-table',
          element: <DashboardTablePage />,
        },
        {
          path: 'farms/:farmId/disease-lab-table',
          element: <DiseaseDashboardTablePage />,
        },
        {
          path: 'farms/:farmId/shrimp-size-table',
          element: <ShrimpSizeTablePage />,
        },
      ],
    },
  ])
}
